/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Contains some Functions for making form validation easy.
 * @type Object
 */
var FormValidation = {
  /**
   * Serialize form inputs.
   * @param {Element} form
   * Form to serialize.
   * @returns {Object}
   */
  serializeForm: function (form) {
    var data = {};
    for (var i = 0, len = form.length; i < len; i++) {
      var input = form[i];
      if (input.name.length > 0) {
        switch (input.type) {
          case "radio":
            if (input.checked) data[input.name] = input.value;

            //if no radio selected, set the key
            if (data[input.name] === undefined) data[input.name] = undefined;

            break;
          case "checkbox":
            //if input name contains '[]' handle it like an array. Else set to true or false.
            if (input.name.indexOf("[]") !== -1) {
              if (data[input.name] === undefined) data[input.name] = [];
              if (input.checked) data[input.name].push(input.value);
            } else {
              data[input.name] = input.checked;
            }
            break;
          default:
            //textareas also has a value
            data[input.name] = input.value;
        }
      }
    }
    return data;
  },
  /**
   * Removes class <i>is-invalid</i> from input parents.
   * MDL adds this class again after a blur event on the input.
   * Should be used after upgrading form with MDL.
   * @param {Element} form
   * Search vor invalid Elements in this form.
   * @returns {undefined}
   */
  removeMDLIsInvalid: function (form) {
    var invalidNodes = form.querySelectorAll(":invalid");
    for (var i = 0, len = invalidNodes.length; i < len; i++)
      invalidNodes[i].parentNode.classList.remove("is-invalid");
  },
  /**
   * Add an <i>onchange</i> event listener to <i>second</i> who check if <i>second</i>s value
   * is equal with the <i>first</i>s value. If not, use HTML5 validation to show message.
   * @param {Element} first
   * This is the Element with reference value.
   * @param {Element} second
   * Error hint on this element.
   * @param {String} message
   * (optional) Message to show in hint.
   * @returns {undefined}
   */
  equalInputs: function (first, second, message) {
    if (message === undefined) {
      if (second.type === "password")
        message = "Die Passwörter stimmen nicht überein.";
      else message = "Die Felder stimmen nicht überein.";
    }

    //This prevents the submit like the standard HTML5 errors.
    //You have to use this additional event listener. If you check this on submit, you could not remove the error hint there.

    second.addEventListener("change", function () {
      //if not required and empty, do not check validity
      if (!this.required && this.value.length === 0) {
        this.setCustomValidity("");
        this.parentNode.classList.remove("is-invalid");
        return;
      }

      //check equality of pw and pw2
      //do not forget add and remove class is-invalid of MDL
      if (first.value !== this.value) {
        this.parentNode.classList.add("is-invalid");
        this.setCustomValidity(message); //set custom error
      } else {
        this.parentNode.classList.remove("is-invalid");
        this.setCustomValidity(""); //this removes custom error. Do not use null here.
      }
    });
  },
  /**
   * Decide if use input type <i>date</i> or <i>text</i>.
   * If date is invalid, input will be cleared. You don't need any validation.
   * @param {Node} node
   * DOM pointer
   * @param {object} options
   * Aviable options from jQueryUI.datepicker:<br/>
   * <i>minDate</i>, <i>defaultDate</i>, <i>maxDate</i>, <i>changeMonth</i>, <i>changeYear</i>, <i>value</i><br/>
   * All are optional.
   * @returns {undefined}
   */
  initDateInput: function (node, options) {
    console.warn("initDateInput() is deprecated. Use DatePicker module.");
    if (typeof $ !== "function") throw new Error("jQuery not found.");

    if (options === undefined) options = {};

    if (options.minDate === undefined) options.minDate = new Date(1920, 1, 1);
    if (options.defaultDate === undefined) options.defaultDate = new Date();
    if (options.maxDate === undefined) options.maxDate = new Date(2020, 0, 1);

    //if value not set, use default date
    if (options.value === undefined)
      options.value = options.defaultDate.toISOString().split("T")[0];
    else options.value = options.value.toISOString().split("T")[0];

    if (/iPad|iPhone|iPod|Android/.test(navigator.userAgent)) {
      //use native datepicker for iOS and Android

      //set min and max attribute
      node.setAttribute("min", options.minDate.toISOString().split("T")[0]);
      node.setAttribute("max", options.maxDate.toISOString().split("T")[0]);

      node.value = options.value;
      node.parentNode.classList.add("is-dirty");
    } else {
      //use jQueryUI datepicker for desktop clients
      //TODO: Somewhen a MDL-Datepicker will be added to the MDL git. Otherwhise, wait for CSS4-UI.

      //change input type to prevent showing the ugly native datepicker
      node.setAttribute("type", "text");

      node.value = ISODateToDateString(options.value);
      node.parentNode.classList.add("is-dirty");

      //initialize jQuery-UI datepicker
      $(node).datepicker({
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        minDate: options.minDate,
        defaultDate: options.defaultDate,
        maxDate: options.maxDate,
        showOtherMonths: true,
        changeMonth: options.changeMonth,
        changeYear: options.changeYear,
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ],
        onSelect: function () {
          this.parentNode.classList.add("is-dirty");
        },
        onClose: function (text) {
          //check date validation. german style

          var arr = text.split(".");
          if (arr.length !== 3) return fail(this);

          if (
            arr[0].length !== 2 || //day
            arr[1].length !== 2 || //month
            arr[2].length !== 4
          )
            //year
            return fail(this);

          /**
           * Romoves value and 'edited' indicator of MDL from <i>node</i>.
           * @param {Node} node
           * @returns {undefined}
           */
          function fail(node) {
            node.value = null;
            node.parentNode.classList.remove("is-dirty");
          }
        },
      });
    }
  },
  /**
   *
   * @param {Element} node
   */
  buttonLoader: function (node) {
    node.classList.add("loader");

    //insert MDL spinner and done icon
    node.insertAdjacentHTML(
      "beforeend",
      '<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"></div>' +
        '<i class="done material-icons">done</i>' +
        '<i class="abort material-icons">close</i>'
    );

    //append function
    node.Loader = {
      /**
       * Transform button to a circle and show loading animation
       */
      start: function () {
        node.classList.add("is-loading");
        node.classList.remove("is-done");
        node.classList.remove("is-abort");
      },
      /**
       * Hide loading animation, show done icon and transform back to normal after 1,5s
       * @param {Function} callback
       */
      end: function (callback) {
        if (node.classList.contains("is-abort")) return;

        node.classList.remove("is-loading");
        node.classList.add("is-done");

        setTimeout(function () {
          node.classList.remove("is-done");

          if (typeof callback === "function") callback();
        }, 1500);
      },
      /**
       * Hide loading animation, show done icon and transform back to normal after 1,5s
       */
      abort: function () {
        if (node.classList.contains("is-done")) return;

        node.classList.remove("is-loading");
        node.classList.add("is-abort");

        setTimeout(function () {
          node.classList.remove("is-abort");
        }, 1500);
      },
    };
  },
  /**
   * Watches for the keyup event on an input and wait some time for triggering the <i>callback</i>.
   * In the meantime, a timeIndicator will be shown on that input.<br>
   * Note: After the initialazation, a wrapper will be build around the input
   * @param {Element} node
   * @param {Function} callback
   * Will be caled with the value of the input
   * @param {Number} delay
   * Delay in ms. Defautl is 500.
   * @returns {undefined}
   */
  delayedTextInput: function (node, callback, delay) {
    delay = delay || 500;

    var wrapper = document.createElement("div");
    wrapper.classList.add("delayed-text-input");

    //add a wrapper around the input
    node.parentNode.insertBefore(wrapper, node);
    wrapper.appendChild(node);

    var indicator = document.createElement("div");
    indicator.classList.add("delay-indicator");
    wrapper.appendChild(indicator);

    node.addEventListener("keyup", function delayHandler(e) {
      var input = this;

      if (this.timeout) clearTimeout(this.timeout);

      this.classList.remove("active");
      requestAnimationFrame(function () {
        input.classList.add("active");
      });

      this.timeout = setTimeout(function () {
        input.classList.remove("active");

        callback(input.value);
      }, delay); //keep this time the same as in css
    });
  },
};
